import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const posPaymentTrendWidget: DashboardWidgetConfiguration = {
  widgetId: "pos.payment-trend",
  name: "POS payment activity",
  description: "POS payment activity across the selected period.",
  apps: [
    "point-of-sale",
  ],
  template: "graph",
  query: {
    kind: "graph",
    valueQuery: {
      version: 1,
      source: "pos.payments",
      ...period(30),
      select: [
        {
          type: "aggregate",
          function: "sum",
          field: "amount",
          as: "value",
        },
      ],
    },
    graphQueries: [
      {
        name: "Payments",
        query: {
          version: 1,
          source: "pos.payments",
          ...period(30),
          select: [
            {
              type: "field",
              field: "paid_at",
              bucket: "day",
              as: "day",
            },
            {
              type: "aggregate",
              function: "sum",
              field: "amount",
              as: "value",
            },
          ],
          group_by: [
            {
              field: "paid_at",
              bucket: "day",
            },
          ],
          order_by: [
            {
              ref: "day",
              direction: "asc",
            },
          ],
        },
        type: "area",
        color: "#206bc4",
        lineWidth: 2,
        fillOpacity: 0.16,
        valueMultiplier: 1,
      },
    ],
  },
  inputs: {
    title: "POS payment activity",
    valueFormat: "currency",
    valueMultiplier: 1,
    graphPadding: true,
    chartHeight: 112,
    curve: "smooth",
  },
  dummyData: {
    value: "$32,840",
    series: [
      18,
      24,
      20,
      32,
      29,
      41,
      48,
    ],
  },
  limits: {
    minWidth: 3,
    maxWidth: 12,
    minHeight: 2,
    maxHeight: 6,
    defaultWidth: 6,
    defaultHeight: 3,
  },
};
